<template>
  <div class="c-content-static-delivery-information flex flex-col text-sm gap-2">
    <h2>Versandkosten</h2>
    <p class="border-b pb-2">
      Bei vielen Artikeln übernehmen wir für Sie die Versandkosten. Sollten doch
      Versandkosten entstehen, entnehmen Sie diese bitte der untenstehenden Tabelle:
    </p>
    <section>
      <h3>
        Paketversand an eine beliebige Adresse Deutschlands
      </h3>
      <div class="grid grid-cols-6">
        <div class="col-span-5">Standard</div>
        <div class="text-right">6,99 €</div>
      </div>
      <div class="grid grid-cols-6 border-b pb-2">
        <div class="col-span-5">Sperrgut</div>
        <div class="text-right">14,99 €</div>
      </div>
      <p>
        Die Versandkostenfreiheit eines Artikels gilt immer für den jeweiligen Artikel bei
        entsprechender Auszeichnung. <br>
        Bei der zusätzlichen Auswahl von versandkostenpflichtigen Artikeln können für diese
        Versandkosten entstehen.
      </p>
    </section>
    <section>
      <h3>Speditionsversand an eine beliebige Adresse Deutschlands</h3>
      <div class="grid grid-cols-6">
        <p class="col-span-5">Lieferung bis zur Bordsteinkante inkl. Avis</p>
        <p class="text-right">59,90 €</p>
      </div>
      <div class="grid grid-cols-6">
        <p class="col-span-5">
          Lieferung bis zur Bordsteinkante inkl. Avis (Side-by-Side Kühlgeräte)
        </p>
        <p class="text-right">79,90 €</p>
      </div>
      <div class="grid grid-cols-6">
        <p class="col-span-5">Lieferung frei Verwendungsstelle inkl. Avis</p>
        <p class="text-right">79,90 €</p>
      </div>
      <p class="border-b pb-2">
        Die Spedition stimmt einen Liefertermin mit Ihnen ab, dadurch kann sich die beim
        Artikel ausgewiesene Lieferzeit verlängern. In der aktuellen Situation kann es sein,
        dass die Lieferung zum Verwendungsort leicht eingeschränkt ausgeführt wird, z.B. der
        Spediteur bis hinter die Wohnungseingangstür liefert, sich aber aus Schutzgründen
        nicht innerhalb Ihrer Wohnung bewegt.
      </p>
    </section>
    <section>
      <h3>Versand per E-Mail</h3>
      <p>
        Beim Kauf von virtuellen Produkten erhalten Sie innerhalb von 15 Minuten einen
        entsprechenden Code zur Aktivierung Ihres Software-Produkts per E-Mail. Hierfür
        fallen keine weiteren Versandkosten für Sie an. Produkte in der digitalen Version
        können nicht zurückgesandt werden und sind nicht erstattbar. Sie stimmen
        ausdrücklich zu, dass mit der Ausführung des Vertrages vor Ablauf der Widerrufsfrist
        begonnen wird und Ihnen ist bekannt, dass Sie durch diese Zustimmung Ihr
        Widerrufsrecht verlieren.
      </p>
    </section>
    <section>
      <h3>Entsorgung Ihrer Altgeräte</h3>
      <p>
        Bei einer Speditionslieferung nehmen wir Ihr Altgerät kostenlos mit und entsorgen es
        fachgerecht. Wählen Sie beim Kauf die Altgerät-Mitnahme als zusätzliche Leistung aus
        und stellen Sie das Altgerät bereit.
      </p>
      <p>
        Bei einer Paketlieferung ist aufgrund technischer Restriktionen ein 1:1 Umtausch im
        Zuge der Lieferung noch nicht möglich. Melden Sie sich bitte bei der Hotline, um ein
        Versandlabel zu erhalten.
      </p>
      <p>
        Des Weiteren nehmen wir Ihr Elektrogerät kostenlos an einer unserer Sammelstellen
        entgegen.
      </p>
      <p>
        Geht aufgrund einer Verunreinigung des Altgeräts eine Gefahr für die Gesundheit und
        Sicherheit von Menschen aus, so kann die Annahme verweigert werden. Dies gilt aber
        grundsätzlich nicht für beschädigte Altgeräte.
      </p>
    </section>
    <section>
      <h3>
        Ausgeschlossene Abhol- und Zustelladressen
      </h3>
      <p>
        Sendungen, bei denen die Abholadresse oder die Zustelladresse ungeeignet oder nur
        unter unverhältnismäßigen Schwierigkeiten erreichbar sind, sind ausgeschlossen.
      </p>
      <p>
        Dazu zählen Postfachanschriften, Packstationen,weitläufige Firmengelände,
        Kleingartenanlagen, Kasernengelände, weitläufige Behördengebäude sowie
        Großkundenpostleitzahlen.
      </p>
    </section>
  </div>
</template>
<style lang="postcss" scoped>
h2 {
  @apply text-primary text-lg py-2;
}
h3 {
  @apply font-bold text-paragraph-light pt-4 pb-2 border-b;
}
section {
  @apply flex flex-col gap-2;
}
</style>
